import React from 'react'
import isEmpty from 'lodash/isEmpty'
import Typography from 'britive-design-system/core/components/typography'

const CSS_CLASS_PREFIX = 'common-approval-modal-itsm-checkout-settings-ticket-list'

const TicketList = ({ list, onClick }) => {
  if (isEmpty(list?.tickets)) {
    return null
  }

  return (
    <>
      <div className={`${CSS_CLASS_PREFIX}-container`}>
        {list?.tickets.map(ticket => (
          <div
            key={`ticket-list-item-${ticket.id}`}
            className={`${CSS_CLASS_PREFIX}-ticket-box`}
            onClick={() => onClick(ticket)}
          >
            <Typography variant="label2">{ticket.number}</Typography>
            <Typography variant="label1">{ticket.title}</Typography>
          </div>
        ))}
      </div>
      {list.totalCount > list.maxResults ? (
        <div className={`${CSS_CLASS_PREFIX}-refine-info`}>
          <Typography variant="label1">
            Showing {list.maxResults} of {list.totalCount} tickets. Please refine
            your search to narrow down the ticket you are looking for.
          </Typography>
        </div>
      ) : null}
    </>
  )
}

export default TicketList
